import React, { useEffect, useState } from 'react'
import { Container, Card, Spinner, Row, Col, Alert } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { MdErrorOutline } from 'react-icons/md'
import withLocation from '../../withLocation'
import { connect } from 'react-redux'
import ContactUsDialog from '../../dialog/contactUsDialog'
import CarImageSection from './carImageSection'
import CarDetailsSection from './carDetailsSection'
import NovatedLeaseSection from './novatedLeaseSection'
import DeductionSection from './deductionSection'
import TakeHomeSection from './takeHomeSection'
import RfbaSection from './rfbaSection'
import ThingsToknow from 'components/thingsToknow'
import {
  OnProposalAuthorisation,
  OnProposalAcceptance,
} from 'actions/proposalsActions'
import { proposalAuthorisedConstants } from 'constants/actionTypes'
import { useHistory } from 'react-router-dom'
import Layout from 'layout'
import { PrimaryButton, SubMenuBar } from '@mmsg/louie'
import { PrimaryLink } from 'components/styledComponents/link'
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  fireInteractionCustomEvent,
  checkConsultant,
  IsVehicleElectric,
  formatCurrency
} from 'helpers'
import * as E from './proposalElements'
import {
  IProposalEstimateProps,
  IAfterMarketAccessoriesProps,
  IProposalVehicleProps,
  IProposalDeductionSectionProps,
  IProposalNovatedLeaseSectionProps,
  IProposalTakeHomeSectionProps,
  IProposalUserEmployer,
} from './proposalTypes'
import { ITheme, IVehicleProps } from 'utils/type'
import zenscroll from 'zenscroll'
import { fetchIndividualEstimate } from 'actions/individualEstimateActions'
import { createPdfBase64 } from 'utils/utilityFunctions'
import {
  startedPdfDownload,
  finishedPdfDownload,
} from 'actions/downloadPdfAction'
import { PdfView } from './../pdf/pdfView'
import BannerMainImageSection from 'components/bannerMainImageSection'
import SpartaCustomerCount from '../estimate-compare/spartaCustomerCount'
import { Icon } from 'icons'

interface IStateEstimatesProps {
  estimates?: { tradeIn?: { negativeEquityAmount?: number } }
}
interface IStateProposalProps {
  proposal: {
    isProposalAuthorised: boolean
    OnProposalAcceptance: {
      isSubmitting: boolean
      errorMsgOnAcceptingProposal: string
      submissionFailed: boolean
    }
    proposal?: { updatedOn: string; isValid: boolean; quoteId: string }
  }
}
interface IStateProposalEstimateProps {
  individualEstimate: {
    estimate: { vehicleFBTValue: number; fbtMethod: string }
  }
}
interface IStateEmployerProps {
  user: { employer: IProposalUserEmployer }
}
interface IStateIndividualEstimateProps {
  individualEstimate: {
    afterMarketAccessories: IAfterMarketAccessoriesProps
    estimate: { vehicle: IVehicleProps }
  }
}

interface IInputProps {
  isAuthenticated: boolean
  opportunityId: string
  consultantFirstName: string
  userFirstName: string
  applicationRole: { isConsultant: boolean }
  evRebateApplicable: boolean
  evRebateLink: string
  evRebateValue: number
  theme: ITheme
}

const ReviewProposal = ({
  isAuthenticated,
  opportunityId,
  consultantFirstName,
  userFirstName,
  applicationRole,
  evRebateApplicable,
  evRebateLink,
  evRebateValue,
  theme,
}: IInputProps) => {
  let dispatch = useDispatch()
  let history = useHistory()
  const isConsultant = applicationRole.isConsultant
  const userEvents = () => {
    if (proposal && proposal.proposal && proposal.proposal.quoteId) {
      dispatch(
        fetchIndividualEstimate(
          opportunityId,
          proposal.proposal.quoteId,
          true,
          true
        )
      )
    }
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'oly:mylease:proposal:review' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'oly:mylease:proposal:review' },
        },
      })
    }
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'review proposal',
          label: 'review proposal',
        },
      },
    })
  }
  const consultantEvents = () => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'oly:mylease:consultant:proposal:review' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'oly:mylease:consultant:proposal:review' },
        },
      })
    }
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'review proposal',
          label: 'review proposal',
        },
      },
    })
  }
  useEffect(() => {
    if (isAuthenticated && opportunityId) {
      checkConsultant() ? consultantEvents() : userEvents()
    }
  }, [isAuthenticated, opportunityId])

  let notificationElement = document.getElementById('notification')
  if (notificationElement) {
    notificationElement.style.display = 'none'
  }
  let contactConsultantLaunchTxt = 'Contact ' + consultantFirstName

  let proposal = useSelector((state: IStateProposalProps) => state.proposal)

  var proposalEstimate: any = useSelector(
    (state: IStateProposalEstimateProps) => state.individualEstimate.estimate
  )

  var userEmployer: IProposalUserEmployer = useSelector(
    (state: IStateEmployerProps) => state.user.employer
  )
  let estimateData: {
    proposalEstimate: IProposalEstimateProps
    userEmployer: {}
  } = {
    proposalEstimate,
    userEmployer,
  }

  let isEVRebate = useSelector(
    (state: IStateIndividualEstimateProps) =>
      evRebateApplicable &&
      IsVehicleElectric(state.individualEstimate.estimate, false) &&
      (state.individualEstimate.estimate.vehicle && state.individualEstimate.estimate.vehicle.vehicleType && 
        state.individualEstimate.estimate.vehicle.vehicleType.toLowerCase() ==='new')
  )

  let showRFBA = useSelector(
    (state: IStateProposalEstimateProps) =>
      IsVehicleElectric(state.individualEstimate.estimate, true) &&
      state.individualEstimate.estimate.vehicleFBTValue &&
      state.individualEstimate.estimate.vehicleFBTValue < 84916 &&
      state.individualEstimate.estimate.fbtMethod &&
      state.individualEstimate.estimate.fbtMethod.toLowerCase() === 'exempt'
  )

  let displayRetailPrice =
    proposalEstimate &&
    proposalEstimate.vehicle.retailPrice &&
    proposalEstimate.vehicle.retailPrice > proposalEstimate.priveawayPrice

  let deductionSectionTitle = () => {
    let title =''
    if (userEmployer && userEmployer.payFrequency) {
      title = '3. Your total ' + userEmployer.payFrequency + ' deductions'
    }
    return title
  }

  
  let takeHomeTitle = '4. Your resulting take home pay' 
  let rfbaTitle = '5. Electric vehicle FBT exemption - what you need to know'
  
  let pointNo = 5
  if (showRFBA) pointNo += 1
  let authorisationTitle = pointNo.toString() + '. Your authorisation'

  let isProposalAuthorised = useSelector(
    (state: IStateProposalProps) => state.proposal.isProposalAuthorised
  )
  let OnProposalAcceptanceState = useSelector(
    (state: IStateProposalProps) => state.proposal.OnProposalAcceptance
  )
  let negativeEquityAmount = useSelector((state: IStateEstimatesProps) =>
    state.estimates && state.estimates.tradeIn
      ? state.estimates.tradeIn.negativeEquityAmount
      : null
  )
  let proposalUpdatedDate: string | null = useSelector(
    (state: IStateProposalProps) =>
      state.proposal && state.proposal.proposal
        ? state.proposal.proposal.updatedOn
        : null
  )

  let OnAuthorisingProposal = () => {
    const propAuthCB = document.getElementById(
      'proposalAuthorisationCheckbox'
    ) as HTMLInputElement
    if (propAuthCB) {
      if (propAuthCB.checked) {
        dispatch(
          OnProposalAuthorisation(
            proposalAuthorisedConstants.PROPOSAL_AUTHORISED
          )
        )
      } else {
        dispatch(
          OnProposalAuthorisation(
            proposalAuthorisedConstants.PROPOSAL_NOT_AUTHORISED
          )
        )
      }
    } else {
      console.log("checkbox doesn't exist")
    }
  }
  const scrollZen = (about: string) => {
    var myDiv: HTMLElement | null = document.getElementById(about)
    if (myDiv) {
      zenscroll.to(myDiv, 100)
    }
  }

  const proceedProposal = (pdf: any) => {
    if (isProposalAuthorised) {
      dispatch(OnProposalAcceptance(opportunityId, proposal, history, pdf))
      fireInteractionCustomEvent({
        detail: {
          eventType: 'custom link click',
          data: {
            category: 'button',
            section: 'mylease',
            text: 'proposal acceptance',
            label: 'proposal acceptance',
          },
        },
      })
    } else if (isProposalAuthorised === undefined) {
      dispatch(
        OnProposalAuthorisation(
          proposalAuthorisedConstants.PROPOSAL_NOT_AUTHORISED
        )
      )
    }
  }

  const pdfViewClick = () => {
    history.push(history.location.pathname + '/pdfview')

    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'view pdf',
          label: 'view pdf',
        },
      },
    })
  }

  const { accessToken } = useSelector((state: any) => state.auth)

  const afterMarketAccessories: IAfterMarketAccessoriesProps = useSelector(
    (state: IStateIndividualEstimateProps) =>
      state.individualEstimate.afterMarketAccessories
  )
  const isProposal = useSelector(
    (state: IStateProposalProps) =>
      state.proposal.proposal && state.proposal.proposal.isValid
  )

  const carImageSectionData: IProposalVehicleProps = proposalEstimate
    ? {
        ...proposalEstimate.vehicle,
        vehicleType: proposalEstimate.vehicleType,
        vehicleDescription: proposalEstimate.vehicleDescription,
      }
    : {}

  const deductionSectionData: IProposalDeductionSectionProps = {
    carRepaymentPerAnnumExGST:
      proposalEstimate && proposalEstimate.carRepaymentPerAnnumExGST,
    carRepaymentPerAnnumIncGST:
      proposalEstimate && proposalEstimate.carRepaymentPerAnnumIncGST,
    carRepaymentPerPayExGST:
      proposalEstimate && proposalEstimate.carRepaymentPerPayExGST,
    carRepaymentPerPayIncGST:
      proposalEstimate && proposalEstimate.carRepaymentPerPayIncGST,
    compInsPerAnnumExGST:
      proposalEstimate && proposalEstimate.compInsPerAnnumExGST,
    compInsPerAnnumIncGST:
      proposalEstimate && proposalEstimate.compInsPerAnnumIncGST,
    compInsPerPayExGST: proposalEstimate && proposalEstimate.compInsPerPayExGST,
    compInsPerPayIncGST:
      proposalEstimate && proposalEstimate.compInsPerPayIncGST,
    compInsurancePremium:
      proposalEstimate && proposalEstimate.compInsurancePremium,
    compInsuranceProvider:
      proposalEstimate && proposalEstimate.compInsuranceProvider,
    electricityCostPerKm:
      proposalEstimate && proposalEstimate.electricityCostPerKm,
    electricityPerAnnumExGST:
      proposalEstimate && proposalEstimate.electricityPerAnnumExGST,
    electricityPerAnnumIncGST:
      proposalEstimate && proposalEstimate.electricityPerAnnumIncGST,
    electricityPerPayExGST:
      proposalEstimate && proposalEstimate.electricityPerPayExGST,
    electricityPerPayIncGST:
      proposalEstimate && proposalEstimate.electricityPerPayIncGST,
    erAdminFeePerAnnum: proposalEstimate && proposalEstimate.erAdminFeePerAnnum,
    erAdminFeePerPay: proposalEstimate && proposalEstimate.erAdminFeePerPay,
    erSharePerAnnum: proposalEstimate && proposalEstimate.erSharePerAnnum,
    erSharePerPay: proposalEstimate && proposalEstimate.erSharePerPay,
    extendedWarrantyPremium:
      proposalEstimate && proposalEstimate.extendedWarrantyPremium,
    fbtMethod: proposalEstimate && proposalEstimate.fbtMethod,
    fbtPerAnnum: proposalEstimate && proposalEstimate.fbtPerAnnum,
    fbtPerPay: proposalEstimate && proposalEstimate.fbtPerPay,
    financierEstablishmentFee:
      proposalEstimate && proposalEstimate.financierEstablishmentFee,
    fuelPerAnnumExGST: proposalEstimate && proposalEstimate.fuelPerAnnumExGST,
    fuelPerAnnumIncGST: proposalEstimate && proposalEstimate.fuelPerAnnumIncGST,
    fuelPerPayExGST: proposalEstimate && proposalEstimate.fuelPerPayExGST,
    fuelPerPayIncGST: proposalEstimate && proposalEstimate.fuelPerPayIncGST,
    gapCoverPremium: proposalEstimate && proposalEstimate.gapCoverPremium,
    greenfleetPerAnnum: proposalEstimate && proposalEstimate.greenfleetPerAnnum,
    greenfleetPerPay: proposalEstimate && proposalEstimate.greenfleetPerPay,
    gstOnECMPerAnnum: proposalEstimate && proposalEstimate.gstOnECMPerAnnum,
    gstOnECMPerPay: proposalEstimate && proposalEstimate.gstOnECMPerPay,
    incidentalsPerAnnumExGST:
      proposalEstimate && proposalEstimate.incidentalsPerAnnumExGST,
    incidentalsPerAnnumIncGST:
      proposalEstimate && proposalEstimate.incidentalsPerAnnumIncGST,
    incidentalsPerPayExGST:
      proposalEstimate && proposalEstimate.incidentalsPerPayExGST,
    incidentalsPerPayIncGST:
      proposalEstimate && proposalEstimate.incidentalsPerPayIncGST,
    lcdaPerAnnum: proposalEstimate && proposalEstimate.lcdaPerAnnum,
    lcdaPerPay: proposalEstimate && proposalEstimate.lcdaPerPay,
    leaseProtectionPremium:
      proposalEstimate && proposalEstimate.leaseProtectionPremium,
    leaseTermYears: proposalEstimate && proposalEstimate.leaseTermYears,
    maintenancePerAnnumExGST:
      proposalEstimate && proposalEstimate.maintenancePerAnnumExGST,
    maintenancePerAnnumIncGST:
      proposalEstimate && proposalEstimate.maintenancePerAnnumIncGST,
    maintenancePerPayExGST:
      proposalEstimate && proposalEstimate.maintenancePerPayExGST,
    maintenancePerPayIncGST:
      proposalEstimate && proposalEstimate.maintenancePerPayIncGST,
    nlFeePerAnnumExGST: proposalEstimate && proposalEstimate.nlFeePerAnnumExGST,
    nlFeePerAnnumIncGST:
      proposalEstimate && proposalEstimate.nlFeePerAnnumIncGST,
    nlFeePerPayExGST: proposalEstimate && proposalEstimate.nlFeePerPayExGST,
    nlFeePerPayIncGST: proposalEstimate && proposalEstimate.nlFeePerPayIncGST,
    noOfTyresBudget: proposalEstimate && proposalEstimate.noOfTyresBudget,
    outOfPocketPerPay: proposalEstimate && proposalEstimate.outOfPocketPerPay,
    regoPerAnnumExGST: proposalEstimate && proposalEstimate.regoPerAnnumExGST,
    regoPerAnnumIncGST: proposalEstimate && proposalEstimate.regoPerAnnumIncGST,
    regoPerPayExGST: proposalEstimate && proposalEstimate.regoPerPayExGST,
    regoPerPayIncGST: proposalEstimate && proposalEstimate.regoPerPayIncGST,
    roadsideAssist: proposalEstimate && proposalEstimate.roadsideAssist,
    roadsidePerAnnumExGST:
      proposalEstimate && proposalEstimate.roadsidePerAnnumExGST,
    roadsidePerAnnumIncGST:
      proposalEstimate && proposalEstimate.roadsidePerAnnumIncGST,
    roadsidePerPayExGST:
      proposalEstimate && proposalEstimate.roadsidePerPayExGST,
    roadsidePerPayIncGST:
      proposalEstimate && proposalEstimate.roadsidePerPayIncGST,
    rpcPremium: proposalEstimate && proposalEstimate.rpcPremium,
    spFeePerAnnumExGST: proposalEstimate && proposalEstimate.spFeePerAnnumExGST,
    spFeePerAnnumIncGST:
      proposalEstimate && proposalEstimate.spFeePerAnnumIncGST,
    spFeePerPayExGST: proposalEstimate && proposalEstimate.spFeePerPayExGST,
    spFeePerPayIncGST: proposalEstimate && proposalEstimate.spFeePerPayIncGST,
    taxShare: proposalEstimate && proposalEstimate.taxShare,
    totalChargesPerPayExGST:
      proposalEstimate && proposalEstimate.totalChargesPerPayExGST,
    totalChargesPerPayExGSTTaxShare:
      proposalEstimate && proposalEstimate.totalChargesPerPayExGSTTaxShare,
    totalChargesPerPayIncGST:
      proposalEstimate && proposalEstimate.totalChargesPerPayIncGST,
    totalChargesPerPayIncGSTTaxShare:
      proposalEstimate && proposalEstimate.totalChargesPerPayIncGSTTaxShare,
    totalPackagePerAnnumExGST:
      proposalEstimate && proposalEstimate.totalPackagePerAnnumExGST,
    totalPackagePerAnnumIncGST:
      proposalEstimate && proposalEstimate.totalPackagePerAnnumIncGST,
    totalPackagePerPayExGST:
      proposalEstimate && proposalEstimate.totalPackagePerPayExGST,
    totalPackagePerPayIncGST:
      proposalEstimate && proposalEstimate.totalPackagePerPayIncGST,
    tyresPerAnnumExGST: proposalEstimate && proposalEstimate.tyresPerAnnumExGST,
    tyresPerAnnumIncGST:
      proposalEstimate && proposalEstimate.tyresPerAnnumIncGST,
    tyresPerPayExGST: proposalEstimate && proposalEstimate.tyresPerPayExGST,
    tyresPerPayIncGST: proposalEstimate && proposalEstimate.tyresPerPayIncGST,
    updatedOn: proposalEstimate && proposalEstimate.updatedOn,
    vehicle: proposalEstimate && proposalEstimate.vehicle,
    erShare: proposalEstimate && proposalEstimate.erShare,
    overTheCapMethod: proposalEstimate && proposalEstimate.overTheCapMethod,
  }

  const proposalEstimateId =
    proposal && proposal.proposal && proposal.proposal.quoteId

  const novatedLeaseSectionData: IProposalNovatedLeaseSectionProps = {
    negativeEquityAmount: negativeEquityAmount,
    downloadingPdf: false,
    pdf: false,
    compInsurancePremium:
      proposalEstimate && proposalEstimate.compInsurancePremium,
    compInsuranceProvider: proposalEstimate && proposalEstimate.compInsuranceProvider,
    driveawayPrice: proposalEstimate && proposalEstimate.driveawayPrice,
    evRebateApplicable,
    evRebateLink,
    evRebateValue,
    extendedWarrantyPremium:
      proposalEstimate && proposalEstimate.extendedWarrantyPremium,
    extendedWarrantyProvider:
      proposalEstimate && proposalEstimate.extendedWarrantyProvider,
    extendedWarrantyTerm:
      proposalEstimate && proposalEstimate.extendedWarrantyTerm,
    financeAmount: proposalEstimate && proposalEstimate.financeAmount,
    financierEstablishmentFee:
      proposalEstimate && proposalEstimate.financierEstablishmentFee,
    gapCoverPremium: proposalEstimate && proposalEstimate.gapCoverPremium,
    gstCreditClaimable: proposalEstimate && proposalEstimate.gstCreditClaimable,
    kmPerAnnum: proposalEstimate && proposalEstimate.kmPerAnnum,
    leaseProtectionPremium:
      proposalEstimate && proposalEstimate.leaseProtectionPremium,
    leaseResidualAmountIncGST:
      proposalEstimate && proposalEstimate.leaseResidualAmountIncGST,
    leaseTerm: proposalEstimate && proposalEstimate.leaseTerm,
    rpcPremium: proposalEstimate && proposalEstimate.rpcPremium,
    rpcProvider: proposalEstimate && proposalEstimate.rpcProvider,
    vehicle: proposalEstimate && {
      ...proposalEstimate.vehicle,
      vehicleType: proposalEstimate && proposalEstimate.vehicleType,
    },
    productId: proposalEstimate && proposalEstimate.productId,
    compInsurancePremiumFinanced:
      proposalEstimate && proposalEstimate.compInsurancePremiumFinanced,
    vehicleFBTValue: proposalEstimate && proposalEstimate.vehicleFBTValue,
  }

  const takeHomeSectionData: IProposalTakeHomeSectionProps = {
    grossSalaryPerPay: proposalEstimate && proposalEstimate.grossSalaryPerPay,
    fbtPerPay: proposalEstimate && proposalEstimate.fbtPerPay,
    taxMedicarePerPay: proposalEstimate && proposalEstimate.taxMedicarePerPay,
    netIncomePerPay: proposalEstimate && proposalEstimate.netIncomePerPay,
    netSalaryPerPay: proposalEstimate && proposalEstimate.netSalaryPerPay,
    otherPostTaxPerPay: proposalEstimate && proposalEstimate.otherPostTaxPerPay,
    otherPreTaxPerPay: proposalEstimate && proposalEstimate.otherPreTaxPerPay,
    postTaxPerPay: proposalEstimate && proposalEstimate.postTaxPerPay,
    preTaxPerPay: proposalEstimate && proposalEstimate.preTaxPerPay,
    takeHomePerPay: proposalEstimate && proposalEstimate.takeHomePerPay,
    fbtMethod: proposalEstimate && proposalEstimate.fbtMethod,
    vehicleFBTValue: proposalEstimate && proposalEstimate.vehicleFBTValue,
  }

  let pdfInBase64: any = ''

  const [displayCustomPdf, setDisplayCustomPdf] = useState(false)
  const onClickCustomPdf = () => {
    setDisplayCustomPdf(true)
    //Print div then disable
    dispatch(startedPdfDownload())
    setTimeout(function () {
      pdfInBase64 = createPdfBase64('Test', 'pdf1', (pdf?: any) => {
        setDisplayCustomPdf(false)
        onPdfProcessComplete(pdf)
      })
    }, 250)
  }

  const onPdfProcessComplete = (pdf: any) => {
    dispatch(finishedPdfDownload())
    proceedProposal(pdf)
  }

  const type = 'proposal'
  return (
    <>
      <Layout>
        <E.ProposalReviewPage id="page">
          <E.SubMenuContainer>
            <SubMenuBar
              background="#000"
              color="#fff"
              buttons={[
                {
                  name: 'Car Details',
                  onClick: () => {
                    scrollZen('cardetailssection')
                  },
                  active: true,
                },
                {
                  name: 'Your Novated Lease',
                  onClick: () => {
                    scrollZen('novatedleasesection')
                  },
                  active: false,
                },
                {
                  name: 'Your Total Deductions',
                  onClick: () => {
                    scrollZen('deductionsection')
                  },
                  active: false,
                },
                {
                  name: 'Your Take Home Pay',
                  onClick: () => {
                    scrollZen('takehomesection')
                  },
                  active: false,
                },
                {
                  name: 'Your Authorisation',
                  onClick: () => {
                    scrollZen('authorisation')
                  },
                  active: false,
                },
                {
                  name: 'Important Info',
                  onClick: () => {
                    scrollZen('termsandconditions')
                  },
                  active: false,
                },
              ]}
              viewPdf={{
                name: 'View PDF',
                onClick: pdfViewClick,
              }}
            />
          </E.SubMenuContainer>

          <div className="banner-estimate-bg" >
      <BannerMainImageSection src='/images/proposal-banner.png'>
        <Row style={{minHeight:'220px'}}>
          <Col lg={10} xs={12}>
            <E.BannerHeader className="mt-3">
            That wide open road is in sight!  
            </E.BannerHeader>
            <E.BannerInfoContent>
              Review the ins and outs of your proposal, before giving it
              the tick to proceed.
              <br />
              Want changes {userFirstName}?{' '}
              {isConsultant ? (
                <PrimaryLink disabled>
                  {contactConsultantLaunchTxt}
                </PrimaryLink>
              ) : (
                <ContactUsDialog
                  className="link font-weight-bold"
                  theme="link"
                  launchText={contactConsultantLaunchTxt}
               
                />
              )}{' '}
              to make them.
            </E.BannerInfoContent>
          </Col>
          
        </Row>
      </BannerMainImageSection>
    </div>
          {isEVRebate && (
            <div id="proposalindex.infobanner">
              <SpartaCustomerCount
                line1={
                  `This electric vehicle may be eligible for a ${formatCurrency(evRebateValue)} EV Bonus!`
                }
                line2={
                  `For more information, chat to your consultant. The ${formatCurrency(evRebateValue)} EV Bonus is not included in any calculations below. ` +
                  ('<a href=' + evRebateLink +
                    ' target="_blank" rel="noopener noreferrer" class="link">' +
                    'Terms &amp; Conditions Apply' +
                    '</a>')
                }
                extended={false}
                icon={<Icon iconType="EVBolt"/>}
                iconTopLine={true}
                spacingValue={3}
              />
            </div>
          )}
          {!proposalEstimate && (
            <Container>
              <div className="mt-5 mb-5 d-flex justify-content-center">
                <img src="/images/loader.gif" alt="" />
              </div>
            </Container>
          )}
          {proposalEstimate && (
            <>
              <CarImageSection
                vehicle={carImageSectionData}
                pdf={false}
                proposalUpdatedDate={proposalUpdatedDate}
              />
              <div id="carDetails">
                <CarDetailsSection
                  vehicle={carImageSectionData}
                  pdf={false}
                  title="1. The car details"
                  proposalUpdatedDate={proposalUpdatedDate}
                />
              </div>
              <div id="summary">
                <NovatedLeaseSection
                  data={novatedLeaseSectionData}
                  title="2. Your novated lease"
                  afterMarketAccessories={afterMarketAccessories}
                  isProposal={isProposal}
                />
              </div>
              <div id="budget"></div>
              <DeductionSection
                data={deductionSectionData}
                userEmployer={userEmployer}
                title={deductionSectionTitle()}
                theme={theme}
                isAnnual={false}
              />
              <TakeHomeSection
                data={takeHomeSectionData}
                title={takeHomeTitle}
                pdf={false}
              />

              {showRFBA && (
                <RfbaSection
                  title={rfbaTitle}
                  pdf={false}
                  includeContainer={true}
                />
              )}

              <div className="card-section" id="authorisation">
                <Container className="section mt-4">
                  <Card className="mb-13rem card-shadow">
                    <Card.Header className="border-bottom-0">
                      <div className="text-header">{authorisationTitle}</div>
                    </Card.Header>
                    <Card.Body>
                      <ol>
                        <li className="mb-1">
                          This is the lease I have discussed with my consultant,
                          and I'm happy to proceed.
                        </li>
                        <li className="mb-1">
                          I acknowledge that the prices and rates specified
                          above may be subject to change by the manufacturer or
                          relavent authorities before delivery.
                        </li>
                        <li className="mb-1">
                          I acknowledge that Oly may receive commissions
                          or rebates and retain interest earned on moneys held
                          in connection with some services it provides or
                          arranges to be provided by third Parties.
                        </li>                      
                        <li className="mb-1">
                          I understand that the lease insurances are optional,
                          and that I won't be able to add them once my lease has
                          begun. Before making a decision on these products I
                          have read the{' '}
                          <E.PDSLink
                            href="https://www.oly.com.au/novated-lease/insurance#pds"
                            target="_blank"
                            rel="noopener noreferrer"
                          >                          
                              Product Disclosure Statements</E.PDSLink>.
                        </li>
                        <br />
                      </ol>
                    </Card.Body>
                  </Card>

                  <E.AuthorizationText
                    className="print hide-to-print"
                    theme={theme}
                  >
                    <input
                      type="checkbox"
                      id="proposalAuthorisationCheckbox"
                      onChange={OnAuthorisingProposal}
                    />{' '}
                    <div>
                      I have read and agree with the above statements.
                      {showRFBA && (
                        <div>
                          I understand the conditions of the Electric Vehicle
                          FBT exemption.
                        </div>
                      )}
                    </div>
                  </E.AuthorizationText>

                  {isProposalAuthorised === false && (
                    <Alert
                      variant="danger"
                      className="d-flex text-left mt-3 w-100"
                    >
                      <MdErrorOutline
                        color="#721c24"
                        size={`1.2em`}
                        style={{ minWidth: '20px' }}
                      />
                      <div className="text-small pl-1">
                        <div className="mb-1">
                          You must agree to the above statements (in the{' '}
                          <i>Your Authorisation</i> section) to proceed with
                          proposal.
                        </div>
                      </div>
                    </Alert>
                  )}

                  <div className="justify-content-around px-md-4 d-flex flex-column flex-md-row mt-3  print hide-to-print">
                    {OnProposalAcceptanceState.isSubmitting ? (
                      <PrimaryButton
                        className="mb-3 ml-3 mr-3"
                        variant="primary"
                      >
                        <>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="mb-1"
                          />
                          Submitting...
                        </>
                      </PrimaryButton>
                    ) : (
                      <PrimaryButton
                        disabled={isConsultant}
                        className="mb-3 ml-3 mr-3"
                        variant="primary"
                        onClick={onClickCustomPdf}
                      >
                        Proceed with proposal
                      </PrimaryButton>
                    )}
                  </div>
                  <div className="d-flex justify-content-around mb-3">
                    {' '}
                    <ContactUsDialog
                      variant="outline-primary"
                      className="d-block mx-auto mt-3 mb-24 mr-2 text-medium btn-lg"
                      theme="link"
                      launchText="Contact my consultant for changes"
                      disabled={isConsultant}
                    />
                  </div>

                  {OnProposalAcceptanceState.submissionFailed && (
                    <div className="errorMsg show text-center">
                      {OnProposalAcceptanceState.errorMsgOnAcceptingProposal}
                    </div>
                  )}
                </Container>
              </div>

              <ThingsToknow
                fbtMethod={proposalEstimate.fbtMethod} displayRetailPrice={false} financierEstablishmentFee={proposalEstimate.financierEstablishmentFee}
              />
            </>
          )}
        </E.ProposalReviewPage>
      </Layout>
      {displayCustomPdf && (
        <div id="pdf1">
          <PdfView
            type
            proposalEstimateId
            accessToken
            opportunityId
            dontScroll
            evRebateApplicable
            evRebateLink
            evRebateValue
          />
        </div>
      )}
    </>
  )
}

function mapStateToProps(
  state: {
    user: {
      firstName: string
      employer: { payFrequency: string; employerGRS: {evRebateApplicable: boolean; evRebateLink: string; evRebateValue: number} }
    }
    applicationRoles: {}
    authentication: { isAuthenticated: boolean; opportunityId: string }
    individualEstimate: { estimate: {} }
    consultant: { firstName: string }
  },
  ownProps: any
) {
  const { isAuthenticated, opportunityId } = state.authentication
  const estimate = state.individualEstimate.estimate || {}
  const { firstName: consultantFirstName } = state.consultant
  const { firstName: userFirstName, employer: { payFrequency } = {} } =
    state.user
  const applicationRole = state.applicationRoles
  const evRebateApplicable = state.user.employer.employerGRS.evRebateApplicable
  const evRebateValue  = state.user.employer.employerGRS.evRebateValue
  const evRebateLink  = state.user.employer.employerGRS.evRebateLink
  return {
    isAuthenticated,
    opportunityId,
    estimate,
    consultantFirstName,
    userFirstName,
    payFrequency,
    applicationRole,
    evRebateApplicable,
    evRebateValue,
    evRebateLink
  }
}

export default connect(mapStateToProps)(withLocation(ReviewProposal))
